import numeral from 'numeral'
import moment from 'moment'

const CurrencyFormatter = value => {
  return numeral(value).format('0,0.00')
}

const Currency = value => {
  return parseFloat(value).toFixed(2)
}

const UpperWord = sentence => {
  return sentence.charAt(0).toUpperCase() + sentence.slice(1)
}

const DigitFormatter = value => {
  return numeral(value).format('0,0')
}

const DateFormatter = (value, format = 'MM/DD/YYYY') => {
  const _value = moment(value)
  return _value.isValid() ? moment(value).format(format) : ''
}

const DateFormatterByAbbreviation = (value, format = 'MMM DD, YYYY') => {
  return moment(value).format(format)
}

const TruncateString = (input, length) => {
  if (input.length > length) {
     return input.substring(0, length) + '...';
  }
  return input;
};

const DateFormatterFromNow = value => {
  return moment(value).fromNow()
}

const LargeNumberFormatter = value => {
  return parseFloat(numeral(value).format('0,0.00'))
}

const NameFormatter = args => {
  const { initial, abr } = args
  const { lastName, firstName, middleName } = args
  const { last_name, first_name, middle_name } = args

  return {
    format1: [lastName || last_name, ',', firstName || first_name, middleName || middle_name, initial, abr]
      .filter(Boolean)
      .join(' '),
    format2: [abr, firstName || first_name, middleName || middle_name, lastName || last_name, initial]
      .filter(Boolean)
      .join(' ')
  }
}

export {
  CurrencyFormatter,
  Currency,
  DigitFormatter,
  UpperWord,
  DateFormatter,
  DateFormatterByAbbreviation,
  DateFormatterFromNow,
  LargeNumberFormatter,
  NameFormatter,
  TruncateString
}
